import RightPopupComponent from "components/RightPopup";

import SelectDateRange from "components/SelectDateRange";
import SelectDate from "components/SelectDate";
import FilterBlock from "pages/clients/components/filterBlock";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';

export default class Template extends RightPopupComponent {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            doctorId: null,
            coordinatorId: null,
            status: null,
            age: null,
            birthDate: null,
            months: null,
            sex: null,
            clinic: null,
            reason: null,
            recommendationType: null,
            dateVisits: null,
            dateLastVisit: null
        };
    }

    renderSelect(src, ind) {
        const { book } = this.props;
        let labelKey = "name";
        if (src === "reasons" || src === "recommendationTypes")
            labelKey = "title";

        return (<div key={"select" + ind} className={`flex col gap16`}>
            {this.insertSelect({
                label: book[src].label,
                showLeftIcon: false,
                placeHolder: "main.notIndicated",
                translate: true,
                items: book[src].rows,
                value: this.state[book[src].state],
                onChange: this.changeState.bind(this, book[src].state),
                labelKey
            })}
        </div>);
    }

    renderDoctors(src, ind) {
        const { doctorId, coordinatorId } = this.state;

        const value = src === "doctor" ? doctorId : coordinatorId;

        return (<div key={"doctor" + ind} className={`flex`}>
            {this.insertSelectDoctor({
                value,
                type: "responsible",
                onClick: this.changeState.bind(this, src === "doctor" ? "doctorId" : "coordinatorId")

            })}
        </div>);
    }

    renderBlank() {
        return (<div className="text p1">
            Нет ни одного приема
        </div>);
    }

    renderDateRange(src, ind) {
        return (<div key={"daterange" + ind} className={`flex`}>
            <SelectDateRange
                ref={el => this.selectDateRange = el}
                inputStyle={"selectrang text p1"}
                selectorStyle={"selectorrang"}
                onForm={this.changeState.bind(this, src)}
                futureOff={false}
                showAddCal={true}
                mode="future" />
        </div>);
    }

    renderBirthDate() {
        return (<div className={`flex`}>
            <SelectDate onClick={this.changeState.bind(this, "birthDate")} />
        </div>);
    }

    renderInput(src, ind) {
        const { age } = this.state;
        return (<div key={"age" + ind} className={`flex`}>
            {this.insertInput({
                type: "number",
                label: "Возраст",
                value: age,
                inputProps: {
                    min: 0,
                    max: 120,
                    step: 1,
                },
                validator: this._helper.inputValidators.number,
                onChange: this.changeState.bind(this, "age")
            })}
        </div>);
    }

    addCondition(currentContent) {
        const { changeState, buferFilter, book } = this.props;

        const { arg: key } = currentContent;
        let text = "";
        let value = false;
        const newBuferFilter = [...buferFilter];

        let checkExistCond = false;

        if (key === "birthDate") {
            const { birthDate } = this.state;
            if (birthDate) {
                value = birthDate;
                text = this._helper.date.toStr(birthDate, "DD.MM.YYYY");
                checkExistCond = buferFilter.find(it => it.key === key && it.value === value);
                if (!checkExistCond && value)
                    newBuferFilter.push({ key, value, text });
            }
        } else if (key === "doctor" || key === "coordinator") {
            const { doctorId, coordinatorId } = this.state;
            value = key === "doctor" ? doctorId : coordinatorId;
            if (value) {
                const info = globalThis.appPageView.getDoctorById(value);
                text = this._helper.string.formatFullName(info, "short");
                checkExistCond = buferFilter.find(it => it.key === key && it.value === value);
                if (!checkExistCond && value)
                    newBuferFilter.push({ key, value, text });
            }
        } else if (key === "dateVisits" || key === "dateLastVisit") {
            const { dateVisits, dateLastVisit, birthDate } = this.state;
            value = key === "dateVisits" ? dateVisits : key === "dateLastVisit" ? dateLastVisit : birthDate;
            const { selectedStartDate, selectedEndDate } = (value || {});
            if (selectedStartDate) {
                text = `${this._helper.date.toStr(selectedStartDate, "DD.MM.YYYY")} - ${this._helper.date.toStr(selectedEndDate, "DD.MM.YYYY")}`;
                checkExistCond = buferFilter.find(it => it.key === key && it.value === value);
                if (!checkExistCond && value)
                    newBuferFilter.push({ key, value, text });
            }
        } else if (key === "blank") {
            checkExistCond = buferFilter.find(it => it.key === key);
            if (!checkExistCond)
                newBuferFilter.push({ key, value: "blank", text: "Нет ни одного приема" });
        } else {
            const { state } = book[currentContent.arg];
            value = this.state[state];

            let name = "name";
            if (state === "reason" || state === "recommendationType")
                name = "title";
            text = this.tr((book[key].rows.find(it => it.id === value) || {})[name]);
            checkExistCond = buferFilter.find(it => it.key === key && it.value === value);
            if (!checkExistCond && value)
                newBuferFilter.push({ key: book[currentContent.arg].state, value, text });
        }

        changeState(newBuferFilter);
    }

    render() {
        const { selectedMenu, buferFilter, changeState } = this.props;
        const content = [
            { func: this.renderSelect.bind(this), arg: "status" },
            { func: this.renderInput.bind(this), arg: "age" },
            /*{ func: this.renderDateRange.bind(this), arg: "birthDate" },*/
            { func: this.renderBirthDate.bind(this), arg: "birthDate" },
            /*{ func: this.renderSelect.bind(this), arg: "months" },*/
            { func: this.renderSelect.bind(this), arg: "sex" },
            { func: this.renderDoctors.bind(this), arg: "doctor" },
            { func: this.renderDoctors.bind(this), arg: "coordinator" },
            { func: this.renderSelect.bind(this), arg: "clinics" },
            /*{ func: this.renderDateRange.bind(this), arg: "dateVisits" },
            { func: this.renderDateRange.bind(this), arg: "dateLastVisit" },
            { func: this.renderBlank.bind(this), arg: "blank" },
            { func: this.renderSelect.bind(this), arg: "reasons" },*/
            { func: this.renderSelect.bind(this), arg: "recommendationTypes" },
        ];

        const currentContent = content[selectedMenu];

        return (currentContent ? <div className="flex col gap16">
            <div>
                {currentContent.func(currentContent.arg, selectedMenu)}
            </div>
            <div style={{ width: "177px" }}>
                {this.insertButton({
                    type: "stroke",
                    size: "small",
                    label: "Добавить условие",
                    icon: < PlusIcon />,
                    onClick: this.addCondition.bind(this, currentContent)
                })}
            </div>
            <div>
                {buferFilter.length > 0 ? <div className="flex gap8 col">
                    <div className="text blockTitle">Выбранные условия</div>
                    <FilterBlock filter={buferFilter} changeState={changeState} />
                </div> :
                    <div className="text blockTitle">Условий пока не выбрано</div>}
            </div>
        </div> : <div className="text blockTitle">Выберите необходимое условие...</div>);
    }
}
